import { render } from "./authpage.vue?vue&type=template&id=d0e2c9aa"
import script from "./authpage.vue?vue&type=script&lang=js"
export * from "./authpage.vue?vue&type=script&lang=js"

import "./authpage.vue?vue&type=style&index=0&id=d0e2c9aa&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__